import { Module } from "wrapper6";
import { toggleClass, hasClass, removeClass, addClass } from "../utils/_class-handlers";

var $ = jQuery;

export default class NavFilter extends Module {

	ready(app) {
        
        this.NAVFILTER = document.querySelector('.nav-filter');
        this.FILTER_TOGGLE = document.getElementById('filter-toggle');

        // Nav toggles
        if (this.NAVFILTER)
            this.navToggles();

        if (this.FILTER_TOGGLE)
            this.filterToggle();
    }

    /**
     * Functionality for filter toggle
     */
    filterToggle() {

        this.TOGGLES_CONTAINER = this.NAVFILTER.querySelector('.toggles');

        if (this.TOGGLES_CONTAINER) {

            this.FILTER_TOGGLE.addEventListener('click', () => {
                toggleClass(this.TOGGLES_CONTAINER, 'open');
                toggleClass(this.FILTER_TOGGLE, 'toggled');
            });
        }
    }

    /**
     * Functionality for nav toggles
     */
    navToggles() {

        this.TOGGLES = this.NAVFILTER.querySelectorAll('.toggles .toggle');

        if (this.TOGGLES.length) {

            for (let i = 0; i < this.TOGGLES.length; i++) {

                const TOGGLE = this.TOGGLES[i];
                const TITLE = TOGGLE.querySelector('.title');
                
                TITLE.addEventListener('click', () => {
                    if (this.getPageWidth() > 960) {
                        this.toggle(TOGGLE);
                    }
                });
            }
        }

        // Hide toggle if clicking on screen
        document.addEventListener('click', (e) => {  
            if (!event.target.closest('.toggle')) {
                this.hideToggles();
            };
        });

        // Hide toggle on escape
        window.addEventListener('keydown', (e) => {
            if (e.keyCode == 27) {
                this.hideToggles();
            }
        });
    }

    // Hide all toggles
    hideToggles() {
        for (let i = 0; i < this.TOGGLES.length; i++) {
            removeClass(this.TOGGLES[i], 'show-dropdown');
        }
    }

    toggle(active) {

        // Remove from all toggles
        for (let i = 0; i < this.TOGGLES.length; i++) {
            removeClass(this.TOGGLES[i], 'show-dropdown');
        }

        // Add to active
        addClass(active, 'show-dropdown');
    }

    getPageWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
}